<template>
    <div id="tryoutgroup-form">
        <v-breadcrumbs :items="[
            { text: 'Dashboard', to: { path: '/' } },
            {
                text: 'Video Pembelajaran',
                to: { path: '/video' },
                exact: true,
            },
            { text: 'Tambah Video Baru' },
        ]" divider="|"></v-breadcrumbs>

        <h3 class="header-text font-weight-bold">
            {{
                !$route.query.id
                    ? "Tambah Video Baru"
                    : "Ubah Video Pembelajaran"
            }}
        </h3>

        <v-card plain class="pa-7">
            <v-list-item two-line class="pa-0">
                <v-list-item-content class="pa-0">
                    <v-list-item-title class="font-weight-bold pb-2">
                        URL Video *
                    </v-list-item-title>
                    <v-text-field placeholder="Masukkan URL Video dan tekan enter" v-model="url" @keypress="hideForm()"
                        outlined />
                    <v-btn v-if="changeUrl" block class="font-weight-bold dark--text" depressed color="#FAFAFA" style="
                            box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
                            border-radius: 4px;
                        " @click="checkURL()">Preview Video</v-btn>
                    <div v-if="!changeUrl" style="width: 50% !important; padding: 0px 0px 20px 0px">
                        <youtube v-if="url && $youtube.getIdFromUrl(url)" :key="videoKey"
                            :video-id="$youtube.getIdFromUrl(url)" ref="youtube" @playing="playing">
                        </youtube>

                    </div>
                </v-list-item-content>
            </v-list-item>
            <div v-if="!changeUrl">
                <v-list-item two-line class="pa-0">
                    <v-list-item-content class="pa-0">
                        <v-list-item-title class="font-weight-bold pa-0">
                            Source
                        </v-list-item-title>

                        <v-radio-group row v-model="source">
                            <v-radio label="Youtube" value="youtube" class="jenjang-selection"
                                active-class="act-radio-btn"></v-radio>
                        </v-radio-group>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item two-line class="pa-0">
                    <v-list-item-content class="pa-0">
                        <v-list-item-title class="font-weight-bold pb-2">
                            Judul Video *
                        </v-list-item-title>
                        <v-text-field placeholder="Judul Video" v-model="judul" outlined
                            :hide-details="!$route.query.id && !$route.query.liveId ? 'auto' : false" />
                        <v-checkbox v-if="!$route.query.id && !$route.query.liveId" label="Judul Alternatif"
                            :value="true" v-model="altTitle" hide-details class="pa-2 ma-0 d-inline-flex" outlined />
                        <v-text-field v-if="altTitle" placeholder="Judul Alternatif" v-model="judulalt" outlined
                            :required="altTitle" />
                    </v-list-item-content>
                </v-list-item>
                <v-list-item two-line class="pa-0">
                    <v-list-item-content class="pa-0">
                        <v-list-item-title class="font-weight-bold pb-2">
                            Durasi *
                        </v-list-item-title>
                        <v-text-field type="number" placeholder="Durasi (dalam detik)" v-model="duration" outlined />
                    </v-list-item-content>
                </v-list-item>
                <v-list-item two-line class="pa-0">
                    <v-list-item-content class="pa-0">
                        <v-list-item-title class="font-weight-bold pb-2">
                            Deskripsi
                        </v-list-item-title>
                        <v-textarea placeholder="Deskripsi" v-model="description" outlined />
                    </v-list-item-content>
                </v-list-item>
                <v-list-item two-line class="pa-0">
                    <v-list-item-content class="pa-0">
                        <v-list-item-title class="font-weight-bold pb-2">
                            Jenjang *
                        </v-list-item-title>

                        <v-radio-group row v-model="jenjang" @change="resetKelas()">
                            <v-radio v-for="item in jenjangList" v-bind:key="item" :label="item" :value="item"
                                class="jenjang-selection" active-class="act-radio-btn"></v-radio>
                        </v-radio-group>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item two-line class="pa-0" v-if="jenjang !== null">
                    <v-list-item-content class="pa-0">
                        <v-list-item-title class="font-weight-bold pb-2">
                            Kelas *
                        </v-list-item-title>
                        <div v-if="jenjang === 'SD'" class="d-inline">
                            <v-checkbox label="1" :value="1" v-model="kelas" class="pa-2 ma-0 d-inline-flex" outlined />
                            <v-checkbox label="2" :value="2" v-model="kelas" class="pa-2 ma-0 d-inline-flex" outlined />
                            <v-checkbox label="3" :value="3" v-model="kelas" class="pa-2 ma-0 d-inline-flex" outlined />
                            <v-checkbox label="4" :value="4" v-model="kelas" class="pa-2 ma-0 d-inline-flex" outlined />
                            <v-checkbox label="5" :value="5" v-model="kelas" class="pa-2 ma-0 d-inline-flex" outlined />
                            <v-checkbox label="6" :value="6" v-model="kelas" class="pa-2 ma-0 d-inline-flex" outlined />
                        </div>
                        <div v-if="jenjang === 'SMP'" class="d-inline">
                            <v-checkbox label="7" :value="7" v-model="kelas" class="pa-2 ma-0 d-inline-flex" outlined />
                            <v-checkbox label="8" :value="8" v-model="kelas" class="pa-2 ma-0 d-inline-flex" outlined />
                            <v-checkbox label="9" :value="9" v-model="kelas" class="pa-2 ma-0 d-inline-flex" outlined />
                        </div>
                        <div v-if="jenjang === 'SMA'" class="d-inline">
                            <v-checkbox label="10" :value="10" v-model="kelas" class="pa-2 ma-0 d-inline-flex"
                                outlined />
                            <v-checkbox label="11" :value="11" v-model="kelas" class="pa-2 ma-0 d-inline-flex"
                                outlined />
                            <v-checkbox label="12" :value="12" v-model="kelas" class="pa-2 ma-0 d-inline-flex"
                                outlined />
                        </div>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item two-line class="pa-0" v-if="jenjang === 'SMA'">
                    <v-list-item-content class="pa-0">
                        <v-list-item-title class="font-weight-bold pb-2">
                            Peminatan
                        </v-list-item-title>

                        <v-radio-group row v-model="interest">
                            <v-radio label="Semua" value="ALL" class="jenjang-selection"
                                active-class="act-radio-btn"></v-radio>
                            <v-radio label="IPA" value="SAINTEK" class="jenjang-selection"
                                active-class="act-radio-btn"></v-radio>
                            <v-radio label="IPS" value="SOSHUM" class="jenjang-selection"
                                active-class="act-radio-btn"></v-radio>
                        </v-radio-group>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item two-line class="pa-0">
                    <v-list-item-content class="pa-0">
                        <v-list-item-title class="font-weight-bold pb-2">
                            Status User </v-list-item-title><v-radio-group row v-model="type">
                            <v-radio id="live_class_type_free" label="FREE" value="FREE" class="jenjang-selection"
                                active-class="act-radio-btn"></v-radio>
                            <v-radio id="live_class_type_premium" label="PREMIUM" value="PREMIUM"
                                class="jenjang-selection" active-class="act-radio-btn"></v-radio>
                        </v-radio-group>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item two-line class="pa-0">
                    <v-list-item-content class="pa-0">
                        <v-list-item-title class="font-weight-bold pb-2">
                            Kurikulum </v-list-item-title>
                        <v-radio-group row v-model="kurikulum">
                            <v-radio label="KM" value="KM" class="pa-2 ma-0 d-inline-flex" outlined />
                            <v-radio label="K13" value="K13" class="pa-2 ma-0 d-inline-flex" outlined />
                            <v-radio label="K13 IPA" value="saintek" class="pa-2 ma-0 d-inline-flex" outlined />
                            <v-radio label="K13 IPS" value="soshum" class="pa-2 ma-0 d-inline-flex" outlined />
                            <v-radio label="TKA" value="TKA" class="pa-2 ma-0 d-inline-flex" outlined />
                        </v-radio-group>

                    </v-list-item-content>
                </v-list-item>
                <v-list-item two-line class="pa-0">
                    <v-list-item-content class="pa-0">
                        <v-list-item-title class="font-weight-bold pb-2">
                            Mata Pelajaran *
                        </v-list-item-title>

                        <v-select class="pa-0" v-model="mapel" :items="mapelList" outlined item-text="nama"
                            item-value="id" placeholder="Ketik mata pelajaran" chips>
                            <template v-slot:selection="{ item }">
                                <v-list-item class="pa-0 ma-0">
                                    <v-list-item-avatar class="ma-0">
                                        <img :src="item.picture" />
                                    </v-list-item-avatar>
                                    <v-list-item-title>{{
                                        item.nama
                                    }}</v-list-item-title>
                                </v-list-item>
                            </template>
                            <template v-slot:item="{ item }">
                                <v-list-item-avatar>
                                    <img :src="item.picture" />
                                </v-list-item-avatar>
                                <v-list-item-title>{{
                                    item.nama
                                }}</v-list-item-title>
                            </template>
                        </v-select>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item two-line class="pa-0">
                    <v-list-item-content class="pa-0">
                        <v-list-item-title class="font-weight-bold pb-2">
                            Topik *
                        </v-list-item-title>
                        <app-autocomplete placeholder="Cari Bab / (Sub) Sub Bab" :data="topics"
                            v-on:selected="assignTopic($event)" :value="topic" :topic="subSubBabId
                                ? subSubBabId
                                : subBabId
                                    ? subBabId
                                    : babId
                                "></app-autocomplete>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item two-line class="pa-0">
                    <v-list-item-content class="pa-0">
                        <v-list-item-title class="font-weight-bold pb-2">
                            Status </v-list-item-title><v-radio-group row v-model="status">
                            <v-radio label="Draft" value="DRAFT" class="jenjang-selection"
                                active-class="act-radio-btn"></v-radio>
                            <v-radio label="Review" value="REVIEW" class="jenjang-selection"
                                active-class="act-radio-btn"></v-radio>
                            <v-radio label="Publikasi" value="PUBLISHED" class="jenjang-selection"
                                active-class="act-radio-btn"></v-radio>
                        </v-radio-group>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item two-line class="pa-0">
                    <v-list-item-content class="pt-0 px-0">
                        <v-list-item-title class="font-weight-bold pb-2">
                            User Group
                        </v-list-item-title>
                        <v-autocomplete :items="user_groups" item-text="user_group_name" item-value="id"
                            placeholder="-- Pilih user group --" outlined v-for="(usgr, i) in user_group" :key="i"
                            v-model="user_group[i]">
                            <template v-slot:append-outer>
                                <v-btn id="user-remove-scope-btn" dark large class="font-weight-bold dark--text"
                                    depressed color="white" v-if="
                                        i === user_group.length - 1 &&
                                        user_group.length != 1
                                    " @click="
                                        queryId ? null : user_group.splice(i, 1)
                                        ">
                                    Hapus
                                </v-btn>
                            </template>
                        </v-autocomplete>
                    </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-btn id="user-add-scope-btn" @click="user_group.push('')" block depressed
                    class="font-weight-bold blew--text mb-5 mt-8" color="#e8f5fa">
                    <v-icon style="font-size: 16px !important" class="mr-1">
                        mdi-plus-circle
                    </v-icon>
                    Tambah User Group Baru
                </v-btn>
                <v-btn block v-if="$route.query.id" class="font-weight-bold blew--text mb-5" depressed color="#e8f5fa"
                    @click="pushNew(), fetchData()">
                    <v-icon style="font-size: 22px !important" class="mr-1">
                        mdi-sort-bool-ascending-variant
                    </v-icon>
                    Atur Urutan Video
                </v-btn>
            </div>
            <v-divider v-if="!changeUrl"></v-divider>
            <v-card-actions class="py-2" v-if="!changeUrl">
                <v-spacer></v-spacer>

                <v-btn color="primary" class="mt-3" depressed @click="
                    !$route.query.id && !$route.query.liveId
                        ? saveData()
                        : editData()
                    ">
                    Simpan
                </v-btn>
            </v-card-actions>
        </v-card>

        <app-spinner v-if="isLoading"></app-spinner>

        <app-modal v-if="showModal" :withCancel="true" v-on:ok="removeDependency()" v-on:cancel="showModal = false">
            <h4 slot="header">Hapus Pra-Syarat</h4>
            <div slot="body">
                Apakah anda yakin akan menghapus pra-syarat
                <strong style="color: red">{{ dependencyName }}</strong> ?
            </div>
        </app-modal>

        <v-dialog v-model="modalUrutan" transition="dialog-top-transition" width="940px" min-height="537px"
            max-height="771px" scrollable @click:outside="modalUrutan = false">
            <template v-slot:default="dialog">
                <v-card>
                    <v-card-title>
                        Urutan Video
                        <span v-if="bab_name" class="ml-2">
                            (Bab {{ bab_name }}
                            <a class="blew--text">Kelas {{ selected_sort_class }}</a>)
                        </span>
                        <v-spacer></v-spacer>

                        <v-progress-circular v-if="loading_sequence" indeterminate color="primary"
                            :size="30"></v-progress-circular>

                        <v-icon v-if="updated_sequence && !loading_sequence" color="blew"
                            style="font-size: 32px">mdi-check-circle</v-icon>
                    </v-card-title>
                    <v-card-subtitle>
                        <div>Atur urutan dengan drag list video</div>

                        <div class="mt-5 mb-5">
                            <v-btn :color="selected_sort_class === data_kelas
                                ? '#e8f5fa'
                                : '#f3f5f7'
                                " :class="selected_sort_class === data_kelas
                                    ? 'blew--text'
                                    : 'grey--text'
                                    " depressed rounded class="mr-2" v-for="(data_kelas, index) of kelas" :key="index"
                                @click="
                                    (selected_sort_class = data_kelas),
                                    fetchData(data_kelas)
                                    ">
                                Kelas {{ data_kelas }}
                            </v-btn>
                        </div>
                    </v-card-subtitle>

                    <v-card-text width="100%">
                        <div class="mt-3 mb-5 pl-4 font-weight-bold">
                            <template>
                                <v-row>
                                    <v-col cols="2">Nomor Urut</v-col>
                                    <v-col cols="8">Nama Video</v-col>
                                </v-row>
                            </template>
                        </div>
                        <div v-if="isLoading" class="mt-8">
                            <v-skeleton-loader v-bind="attrs" type="card"></v-skeleton-loader>
                        </div>
                        <div v-if="!isLoading">
                            <draggable :list="video2" :disabled="!enabled" class="list-group" ghost-class="ghost"
                                :move="checkMove" @start="dragging = true" @end="finishDragged">
                                <div class="list-group-item pa-6 draggable" v-for="(element, index) in video2" :class="element.id == $route.query.id
                                    ? 'selected'
                                    : ''
                                    " :key="element.id">
                                    <v-row>
                                        <v-col cols="2" md="2">
                                            <v-btn :color="element.id ==
                                                $route.query.id
                                                ? '#29b6f6'
                                                : 'blew'
                                                " class="font-weight-bold" style="font-size: 14px" rounded fab x-small
                                                dark depressed>
                                                {{ index + 1 }}
                                            </v-btn>
                                        </v-col>
                                        <v-col cols="8" md="8" class="pt-1">
                                            {{ element.nama_video }}
                                        </v-col>
                                    </v-row>
                                </div>

                                <div class="text-center" v-if="!video2.length">
                                    Video tidak tersedia
                                </div>
                            </draggable>
                        </div>

                        <v-simple-table class="pa-0" style="display: none">
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-left">Nomor Urut</th>
                                        <th class="text-left" width="80%">
                                            Nama Video
                                        </th>
                                        <th class="text-left">Aksi</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(video, index) in sortedVideo" :key="index" :color="video.id == $route.query.id ||
                                        video.nama_video === judul
                                        ? '#F9F9FB'
                                        : ''
                                        ">
                                        <td>{{ video.no_urut }}</td>
                                        <td>{{ video.nama_video }}</td>
                                        <td>
                                            <v-btn class="pa-0" min-width="32px" height="32px" elevation="0" v-if="
                                                video.no_urut > 1 &&
                                                (video.id ==
                                                    $route.query.id ||
                                                    video.new)
                                            " @click="moveUp(video)">
                                                <v-icon>mdi-menu-up</v-icon>
                                            </v-btn>
                                            <v-btn class="pa-0" min-width="32px" height="32px" elevation="0" v-if="
                                                video.id ==
                                                $route.query.id ||
                                                video.new
                                            " @click="moveDown(video)">
                                                <v-icon>mdi-menu-down</v-icon>
                                            </v-btn>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-card-text>
                    <v-card-text>
                        <div class="text-h2"></div>
                    </v-card-text>
                    <v-card-actions class="justify-end">
                        <v-btn text @click="dialog.value = false">Close</v-btn>
                    </v-card-actions>
                </v-card>
            </template>
        </v-dialog>
    </div>
</template>

<script>
import _ from "lodash";
import Autocomplete from "@/modules/global/components/plugins/Autocomplete";
import ItembankService from "@/modules/itembank/services/itembank.js";
import LabelAutocomplete from "@/modules/global/components/plugins/LabelAutocomplete";
import Modal from "@/modules/global/components/plugins/Modal";
import moment from "moment";
import Spinner from "@/modules/global/components/plugins/Spinner";
import TryoutChooser from "@/modules/tryout_group/components/TryoutChooser";
import TryoutGroupChooser from "@/modules/tryout_group/components/TryoutGroupChooser";
import VideoService from "@/modules/vd_pembelajaran/services/video.js";
import axios from "axios";
import draggable from "vuedraggable";

export default {
    name: "tryoutgroup-form",

    components: {
        "app-autocomplete": Autocomplete,
        "app-labelAutocomplete": LabelAutocomplete,
        "app-modal": Modal,
        "app-tryoutchooser": TryoutChooser,
        "app-tryoutgroupchooser": TryoutGroupChooser,
        "app-spinner": Spinner,
        draggable,
    },

    data: function () {
        return {
            modul: null,
            isLoading: false,
            showModal: false,
            modalUrutan: false,
            successbyurl: false,
            errors: [],
            topics: [],
            videoId: null,
            judulalt: null,
            changeUrl: true,
            altTitle: false,
            jenjangList: ["SD", "SMP", "SMA"],
            gradeList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
            mapelList: JSON.parse(localStorage.getItem("mapels")),
            jenjang: null,
            start_date: null,
            start_time: null,
            end_date: null,
            end_time: null,
            topic: null,
            babId: null,
            subBabId: null,
            subSubBabId: null,
            videoKey: 0,
            video2: [],
            videos: [],
            no_urut: null,
            lastSequence: 0,
            type: null,
            queryId: null,
            enabled: true,
            list: [],
            dragging: false,
            list_sorted_video: [],
            updated_sequence: false,
            loading_sequence: false,
            bab_name: null,
            selected_sort_class: null,
        };
    },

    created() { },

    watch: {
        altTitle: function (val, oldval) {
            if (!val) {
                this.judulalt = this.judul;
            }
        },

        mapel() {
            this.getItembanks();
        },
    },

    computed: {
        player() {
            return this.$refs.youtube.player;
        },

        url: {
            get: function () {
                return this.$store.state.video.url;
            },

            set: function (value) {
                this.$store.commit("video_set_url", value);
            },
        },

        judul: {
            get: function () {
                return this.$store.state.video.title;
            },

            set: function (value) {
                this.$store.commit("video_set_title", value);
            },
        },

        kelas: {
            get: function () {
                return this.$store.state.video.grade.sort();
            },

            set: function (value) {
                this.$store.commit("video_set_grade", value);
            },
        },

        mapel: {
            get: function () {
                return this.$store.state.video.mapel;
            },

            set: function (value) {
                this.$store.commit("video_set_mapel", value);
            },
        },

        user_group: {
            get: function () {
                return this.$store.state.video.user_groups;
            },

            set: function (value) {
                this.$store.commit("video_set_user_group", value);
            },
        },

        interest: {
            get: function () {
                return this.$store.state.video.interest;
            },

            set: function (value) {
                this.$store.commit("video_set_interest", value);
            },
        },

        description: {
            get: function () {
                return this.$store.state.video.description;
            },

            set: function (value) {
                this.$store.commit("video_set_description", value);
            },
        },

        // type: {
        //   get: function () {
        //     return this.$store.state.video.type;
        //   },

        //   set: function (value) {
        //     this.$store.commit("video_set_type", value);
        //   },
        // },

        thumbnail: {
            get: function () {
                return this.$store.state.video.thumbnail;
            },

            set: function (value) {
                this.$store.commit("video_set_thumbnail", value);
            },
        },

        source: {
            get: function () {
                return this.$store.state.video.source;
            },

            set: function (value) {
                this.$store.commit("video_set_source", value);
            },
        },

        kurikulum: {
            get: function () {
                return this.$store.state.video.kurikulum;
            },

            set: function (value) {
                this.$store.commit("video_set_kurikulum", value);
            },
        },

        status: {
            get: function () {
                return this.$store.state.video.status;
            },

            set: function (value) {
                this.$store.commit("video_set_status", value);
            },
        },
        duration: {
            get: function () {
                return this.$store.state.video.duration;
            },

            set: function (value) {
                this.$store.commit("video_set_duration", value);
            },
        },

        sortedVideo() {
            return _.orderBy(this.video2, ["no_urut"], ["asc"]);
        },

        draggingInfo() {
            return this.dragging ? "under drag" : "";
        },
    },
    watch: {
        '$route.query.id'(newId) {
            if (newId) {
                this.loadVideo(newId);
            } else {
                this.resetForm();
            }
        },
        altTitle(val) {
            if (!val) {
                this.judulalt = this.judul;
            }
        },
        mapel() {
            this.getItembanks();
        }
    },

    methods: {
        playVideo() {
            this.player.playVideo();
        },

        playing() {
            console.log("o/ we are watching!!!");
        },

        hideForm() {
            this.changeUrl = true;
        },

        resetKelas() {
            this.kelas = [];
            this.interest = "ALL";
        },

        checkURL() {
            if (!this.url) {
                this.$store.commit("showAlert", { message: "URL diperlukan", type: "error" });
                return;
            }

            if (this.url.includes("embed")) {
                this.$store.commit("showAlert", { message: "Video URL tidak valid", type: "error" });
                return;
            }

            const id = this.$youtube.getIdFromUrl(this.url);
            if (!id) {
                this.$store.commit("showAlert", { message: "Video ID tidak valid", type: "error" });
                return;
            }

            this.changeUrl = false;
            this.successbyurl = true;
            this.videoKey++; // force refresh
        },

        loadVideo(id) {
            this.isLoading = true;
            VideoService.getVideoDetailById(id, (response) => {
                this.isLoading = false;
                if (response.success && response.data) {
                    this.changeUrl = false;
                    this.successbyurl = true;
                    this.videoKey++;

                    this.judul = response.data.title || "";
                    this.judulalt = response.data.title || "";
                    this.source = response.data.source || "youtube";
                    this.thumbnail = response.data.thumbnail || "";
                    this.description = response.data.description || "";
                    this.duration = response.data.duration_in_sec || "";
                    this.kurikulum = response.data.kurikulum || "";
                    this.status = response.data.status || "";
                } else {
                    this.resetForm();
                    this.$store.commit("showAlert", {
                        message: "Gagal memuat data video!",
                        type: "error",
                    });
                }
            });
        },

        resetForm() {
            this.url = "";
            this.judul = "";
            this.judulalt = "";
            this.description = "";
            this.duration = "";
            this.videoId = null;
            this.changeUrl = true;
            this.videoKey++;
        },

        fetchData: function () {
            this.modalUrutan = true;

            var context = this;
            context.isLoading = true;

            if (context.babId === null) {
                context.babId = "0";
            }

            context.selected_sort_class =
                context.selected_sort_class || context.kelas[0];
            var grade = context.kelas.length ? context.selected_sort_class : "";

            try {
                VideoService.getListVideoByBab(
                    context.babId,
                    grade,
                    function (result) {
                        context.videos = [];
                        context.video2 = [];

                        if (result.success) {
                            context.videos = result.data.list_video;
                            result.data.list_video.forEach((e) => {
                                // if (e.nama_video == context.judul) {
                                //   // seq++;
                                // e.sequence = e.no_urut ? e.no_urut : 99;
                                context.video2.push(e);
                                // }
                            });
                            context.video2 = _.orderBy(
                                context.video2,
                                ["no_urut"],
                                ["asc"]
                            );
                            context.lastSequence = context.video2.length;
                        }
                        context.isLoading = false;
                    }
                );
            } catch (error) {
                context.isLoading = false;
            }
        },

        moveUp: function (videoDetail) {
            const itemIndex = this.video2.findIndex(
                (s) => videoDetail.id === s.id
            );
            this.no_urut = videoDetail.no_urut - 1;
            this.video2[itemIndex].no_urut = this.no_urut;
            this.changeVideoSequence(videoDetail.id, this.no_urut);
        },

        moveDown: function (videoDetail) {
            const itemIndex = this.video2.findIndex(
                (s) => videoDetail.id === s.id
            );
            this.no_urut = videoDetail.no_urut + 1;
            this.video2[itemIndex].no_urut = this.no_urut;
            this.changeVideoSequence(videoDetail.id, this.no_urut);
        },

        changeVideoSequence(id, nomor) {
            var context = this;
            var body = context.list_sorted_video;
            context.loading_sequence = true;
            context.updated_sequence = false;

            VideoService.changeSequence(body, function (result) {
                if (result.success) {
                    context.updated_sequence = true;
                    // context.$store.commit("showAlert", {
                    //   message: `Berhasil Mengubah Urutan Video!`,
                    //   type: "success",
                    // });
                } else {
                    console.log(result);
                    context.$store.commit("showAlert", {
                        message: `Terjadi kesalahan`,
                        submessage: "Urutan video tidak berubah",
                        type: "error",
                    });
                }

                setTimeout(() => {
                    context.loading_sequence = false;
                }, 1000);
            });
        },

        validateForm: function () {
            var err = false;
            this.judul = this.judul.trim();
            this.url = this.url.trim();

            if (this.url == null || this.url == "" || this.url == " ") {
                this.$store.commit("showAlert", {
                    message: `URL Video wajib diisi!`,
                    type: "error",
                });
                err = true;
            }

            if (this.judul == null || this.judul == "" || this.judul == " ") {
                this.$store.commit("showAlert", {
                    message: `Judul wajib diisi!`,
                    type: "error",
                });
                err = true;
            }

            if (
                this.duration == null ||
                this.duration == 1 ||
                this.duration == ""
            ) {
                this.$store.commit("showAlert", {
                    message: `Durasi wajib diisi!`,
                    type: "error",
                });
                err = true;
            }

            if (this.source == null || this.source == "") {
                this.$store.commit("showAlert", {
                    message: `Source wajib diisi!`,
                    type: "error",
                });
                err = true;
            }

            if (this.kelas == null || this.kelas.length < 1) {
                this.$store.commit("showAlert", {
                    message: `Kelas wajib diisi!`,
                    type: "error",
                });
                err = true;
            }

            if (this.mapel == null || this.mapel == "") {
                this.$store.commit("showAlert", {
                    message: `Mata Pelajaran wajib diisi!`,
                    type: "error",
                });
                err = true;
            }

            if (this.topic == null || this.topic == "") {
                this.$store.commit("showAlert", {
                    message: `Topik wajib diisi!`,
                    type: "error",
                });
                err = true;
            }

            if (
                this.kelas > 9 &&
                (this.interest == null || this.interest == "")
            ) {
                this.$store.commit("showAlert", {
                    message: `Jurusan wajib diisi!`,
                    type: "error",
                });
                err = true;
                this.errors.push("Jurusan wajib diisi");
            }

            if (this.kelas < 10) {
                this.interest = "ALL";
            }

            return !err;
        },

        saveData: function () {
            if (!this.validateForm()) {
                return;
            }

            if (this.$route.name === "VideoMaterialLiveStream") {
                this.isLoading = true;
                var context = this;
                var body = {
                    title: this.judulalt,
                    description: this.description,
                    interest: this.interest,
                    source: this.source,
                    youtube_url: this.url,
                    grades: this.kelas,
                    type: this.type,
                    mapel_id: this.mapel,
                    start_date: this.start_date,
                    end_date: this.end_date,
                    start_time: this.start_time,
                    end_time: this.end_time,
                    no_urut: this.no_urut,
                    module_id: this.modul != null ? this.modul.id : null,
                    user_group: this.user_group,
                    kurikulum: this.kurikulum,
                    status: this.status,
                };

                VideoService.addVideoLiveStreaming(body, function (result) {
                    context.isLoading = false;
                    context.$store.commit("video_reset", result.data);
                    context.start_date = "";
                    context.start_time = "";
                    context.end_date = "";
                    context.end_time = "";

                    if (context.modul != null) {
                        context.$router.push({
                            path: "/modul-belajar/live-stream",
                            query: { modul_id: context.modul.id },
                        });
                    } else {
                        if (result.success) {
                            context.$store.commit("showAlert", {
                                message: `Berhasil Menyimpan Data!`,
                                type: "success",
                            });
                        } else {
                            context.$store.commit("showAlert", {
                                message: `Terjadi kesalahan`,
                                submessage: "Data tidak tersimpan",
                                type: "error",
                            });
                        }
                        context.$router.push({ path: "/video" });
                    }
                });
            } else {
                this.isLoading = true;
                var context = this;
                var body = {
                    title: this.judulalt || this.judul,
                    description: this.description,
                    interest: this.interest,
                    source: this.source,
                    youtube_url: this.url,
                    grades: this.kelas,
                    type: this.type,
                    mapel_id: this.mapel,
                    bab_id: this.babId,
                    subbab_id: this.subBabId,
                    subsubbab_id: this.subSubBabId,
                    duration: this.duration,
                    no_urut: this.no_urut,
                    module_id: this.modul != null ? this.modul.id : null,
                    user_group: this.user_group,
                    kurikulum: this.kurikulum,
                    status: this.status,
                };

                VideoService.addVideo(body, function (result) {
                    context.isLoading = false;
                    context.$store.commit("video_reset", result.data);

                    if (context.modul != null) {
                        context.$router.push({
                            path: "/modul-belajar/materials",
                            query: { modul_id: context.modul.id },
                        });
                    } else {
                        if (result.success) {
                            context.$store.commit("showAlert", {
                                message: `Berhasil Menyimpan Data!`,
                                type: "success",
                            });
                        } else {
                            context.$store.commit("showAlert", {
                                message: `Terjadi kesalahan`,
                                submessage: "Data tidak tersimpan",
                                type: "error",
                            });
                        }
                        context.$router.push({ path: "/video" });
                    }
                });
            }
        },

        editData: function () {
            if (!this.validateForm()) {
                return;
            }

            if (this.$route.name === "VideoMaterialLiveStream") {
                this.isLoading = true;
                var context = this;
                var body = {
                    title: this.$store.state.video.title,
                    description: this.$store.state.video.description,
                    interest: this.$store.state.video.interest,
                    source: this.$store.state.video.source,
                    youtube_url: this.$store.state.video.url,
                    grades: this.$store.state.video.grade,
                    type: this.type,
                    mapel_id: this.$store.state.video.mapel,
                    start_date: this.start_date,
                    end_date: this.end_date,
                    start_time: this.start_time,
                    end_time: this.end_time,
                    no_urut: this.no_urut,
                    module_id: this.modul != null ? this.modul.id : null,
                    user_group: this.user_group,
                    kurikulum: this.kurikulum,
                    status: this.status,
                };

                VideoService.editVideoLiveStreaming(
                    this.$route.query.liveId,
                    body,
                    function (result) {
                        context.isLoading = false;
                        context.$store.commit("video_reset", result.data);
                        context.start_date = "";
                        context.start_time = "";
                        context.end_date = "";
                        context.end_time = "";

                        if (context.modul != null) {
                            context.$router.push({
                                path: "/modul-belajar/live-stream",
                                query: {
                                    modul_id: context.$route.query.module,
                                },
                            });
                        } else {
                            if (result.success) {
                                context.$store.commit("showAlert", {
                                    message: `Berhasil Menyimpan Data!`,
                                    type: "success",
                                });
                            } else {
                                context.$store.commit("showAlert", {
                                    message: `Terjadi kesalahan`,
                                    submessage: "Data tidak tersimpan",
                                    type: "error",
                                });
                            }
                            context.$router.push({ path: "/video" });
                        }
                    }
                );
            } else {
                this.isLoading = true;
                var context = this;
                var body = {
                    title: this.$store.state.video.title,
                    description: this.$store.state.video.description,
                    interest: this.$store.state.video.interest,
                    source: this.$store.state.video.source,
                    youtube_url: this.$store.state.video.url,
                    grades: this.$store.state.video.grade,
                    type: this.type,
                    mapel_id: this.$store.state.video.mapel,
                    duration: this.$store.state.video.duration,
                    bab_id: this.babId,
                    subbab_id: this.subBabId,
                    subsubbab_id: this.subSubBabId,
                    duration: this.duration,
                    no_urut: this.no_urut,
                    module_id: this.modul != null ? this.modul.id : null,
                    user_group: this.user_group,
                    kurikulum: this.kurikulum,
                    status: this.status,
                };

                VideoService.editVideo(
                    this.$route.query.id,
                    body,
                    function (result) {
                        context.isLoading = false;
                        context.$store.commit("video_reset", result.data);

                        if (context.$route.name === "VideoMaterial") {
                            context.$router.push({
                                path: "/modul-belajar/materials",
                                query: {
                                    modul_id: context.$route.query.module,
                                },
                            });
                        } else {
                            if (result.success) {
                                context.$store.commit("showAlert", {
                                    message: `Berhasil Menyimpan Data!`,
                                    type: "success",
                                });
                            } else {
                                context.$store.commit("showAlert", {
                                    message: `Terjadi kesalahan`,
                                    submessage: "Data tidak tersimpan",
                                    type: "error",
                                });
                            }
                            context.$router.push({ path: "/video" });
                        }
                    }
                );
            }
        },

        pushNew() {
            var found = this.video2.find((e) => e.id == this.babId);
            if (!found) {
                var data = this.videos;
                this.video2.push(data);
                this.video2 = _.orderBy(this.video2, ["sequence"], ["asc"]);
                this.lastSequence = this.video2.length;
            }
        },

        getMapelById: function (mapelId) {
            var mapel = JSON.parse(localStorage.getItem("mapels"));
            var found = mapel.find(function (element) {
                return element.id == mapelId;
            });

            return found;
        },

        assignTopic: function (result) {
            var topicIds = result.data;
            this.babId = topicIds[0];
            this.subBabId = topicIds[1];
            this.subSubBabId = topicIds[2];
            this.topic = result.text;
        },

        getItembanks() {
            var context = this;
            var mapelId = this.$store.state.video.mapel
                ? this.$store.state.video.mapel
                : this.mapel;
            var mapel = this.getMapelById(mapelId);
            ItembankService.getListOfTopic(mapel.code, function (result) {
                context.topics = result.data;
            });
        },

        getUserGroupData() {
            this.user_groups = [];
            const url =
                process.env.API_BASE_URL +
                "/payment/list/user_group?page=1&per_page=1000";

            const authToken = JSON.parse(localStorage.getItem("token")).value;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };
            const context = this;
            axios.get(url, options).then(function (response) {
                if (response.status === 200) {
                    context.user_groups = response.data.user_groups;
                }
            });
        },
        checkMove: function (e) {
            window.console.log("Future index: " + e.draggedContext.futureIndex);
        },
        finishDragged() {
            this.dragging = false;
            this.list_sorted_video = [];

            this.video2.map((res, index) => {
                var no_urut = index + 1;

                this.list_sorted_video.push({
                    id: res.id,
                    no_urut: no_urut,
                });

                if (res.id === this.$route.query.id) {
                    this.no_urut = no_urut;
                }
            });

            this.changeVideoSequence();
        },
    },

    mounted: function () {
        var context = this;

        DatepickerPlugin.init("#startDate", function (value) {
            context.start_date = moment(value, "DD/MM/YYYY").format(
                "YYYY-MM-DD"
            );
        });

        DatepickerPlugin.init("#endDate", function (value) {
            context.end_date = moment(value, "DD/MM/YYYY").format("YYYY-MM-DD");
        });

        ClockpickerPlugin.init("#startTime", function (value) {
            context.start_time = value + ":00";
        });

        ClockpickerPlugin.init("#endTime", function (value) {
            context.end_time = value + ":00";
        });
        this.$nextTick(() => {
            if (this.videoId) {
                this.videoKey++; // force re-render preview
            }
        });

        if (this.$route.query.id) {
            var context = this;
            this.changeUrl = false;

            VideoService.getVideoDetailById(
                this.$route.query.id,
                function (result) {
                    var gradeWrap = [];
                    var jenjangWrap = "";
                    if (result.data.grades.length > 0) {
                        for (var i = 0; i < result.data.grades.length; i++) {
                            gradeWrap.push(result.data.grades[i].grade);
                            jenjangWrap = result.data.grades[i].jenjang.nama;
                        }
                    }
                    var bab = result.data.bab ? result.data.bab.nama : "";
                    var subbab = result.data.sub_bab_id
                        ? " >> " + result.data.sub_bab_id.nama
                        : "";
                    var subsubbab = result.data.sub_sub_bab_id
                        ? " >> " + result.data.sub_sub_bab_id.nama
                        : "";

                    context.judul = result.data.title;
                    context.url = result.data.youtube_url;
                    context.jenjang = jenjangWrap;
                    context.kelas = gradeWrap;
                    context.source = result.data.source;
                    context.mapel = result.data.mapel.id;
                    context.type = result.data.type;
                    context.no_urut = result.data.no_urut;
                    context.interest =
                        result.data.interest === "OTHER"
                            ? "ALL"
                            : result.data.interest;
                    context.duration = result.data.duration;
                    context.description = result.data.description;
                    context.videoId = result.data.youtube_url.substring(
                        result.data.youtube_url.indexOf("=") + 1
                    );
                    context.videoKey++;;
                    context.babId = result.data.bab ? result.data.bab.id : null;
                    context.subBabId = result.data.sub_bab_id
                        ? result.data.sub_bab_id.id
                        : null;
                    context.subSubBabId = result.data.sub_sub_bab_id
                        ? result.data.sub_sub_bab_id.id
                        : null;
                    context.topic = bab + subbab + subsubbab;
                    context.bab_name = result.data.bab.nama;
                    context.kurikulum = result.data.kurikulum;
                    context.status = result.data.status;

                    document.title = context.judul;

                    var userGroup = [];
                    if (result.data.user_groups.length > 0) {
                        for (
                            var i = 0;
                            i < result.data.user_groups.length;
                            i++
                        ) {
                            userGroup.push(result.data.user_groups[i].id);
                        }
                    }

                    context.user_group = userGroup;
                    console.log(
                        context.judul,
                        context.jenjang,
                        context.kelas,
                        context.type
                    );
                }

            );

        }

        if (this.$route.query.modul_id) {
            var modulId = this.$route.query.modul_id;
            var context = this;
            ItembankService.getModulBelajar(modulId, function (response) {
                if (response.success) {
                    context.modul = response.data;
                }
            });
        }

        if (this.$route.query.liveId) {
            var liveId = this.$route.query.liveId;
            var context = this;

            ItembankService.getLiveStream(liveId, function (result) {
                if (result.success) {
                    context.changeUrl = false;
                    context.modul = {
                        name: result.data.module.name,
                    };
                    var gradeWrap = [];
                    var jenjangWrap = "";
                    if (result.data.grades.length > 0) {
                        for (var i = 0; i < result.data.grades.length; i++) {
                            gradeWrap.push(result.data.grades[i].grade);
                            jenjangWrap = result.data.grades[i].jenjang.nama;
                        }
                    }
                    var bab = result.data.bab ? result.data.bab.nama : "";
                    var subbab = result.data.sub_bab_id
                        ? " >> " + result.data.sub_bab_id.nama
                        : "";
                    var subsubbab = result.data.sub_sub_bab_id
                        ? " >> " + result.data.sub_sub_bab_id.nama
                        : "";
                    context.start_date = result.data.start_date;
                    context.start_time = result.data.start_time;
                    context.end_date = result.data.end_date;
                    context.end_time = result.data.end_time;
                    context.judul = result.data.title;
                    context.url = result.data.youtube_url;
                    context.type = result.data.type;
                    context.jenjang = jenjangWrap;
                    context.kelas = gradeWrap;
                    context.source = result.data.source;
                    context.mapel = result.data.mapel.id;
                    context.no_urut = result.data.no_urut;
                    context.interest =
                        result.data.interest === "OTHER"
                            ? "ALL"
                            : result.data.interest;
                    context.duration = result.data.duration;
                    context.description = result.data.description;
                    context.videoId = result.data.youtube_url.substring(
                        result.data.youtube_url.indexOf("=") + 1
                    );
                    context.videoKey++;;
                    context.babId = result.data.bab
                        ? result.data.bab_id.id
                        : null;
                    context.subBabId = result.data.sub_bab_id
                        ? result.data.sub_bab_id.id
                        : null;
                    context.subSubBabId = result.data.sub_sub_bab_id
                        ? result.data.sub_sub_bab_id.id
                        : null;
                    context.topic = bab + subbab + subsubbab;
                    context.kurikulum = result.data.kurikulum;
                    context.status = result.data.status;
                }
            });
        }

        this.getUserGroupData();
        this.getItembanks();
    },
};
</script>

<style>
.draggable {
    cursor: all-scroll !important;
}

.selected {
    background-color: #00897b;
    color: #fff !important;
}

.ghost {
    opacity: 1;
    background: #ececec;
    cursor: all-scroll !important;
}
</style>


// WEBPACK FOOTER //
// Form.vue?b00ccac8